const initialState = {
    responseWhyChooseUsList: {},
    responseWhyChooseUs: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "WHY_CHOOSE_US_LIST_RESPONSE":
            newState.responseWhyChooseUsList = action.value
            break;
        case "WHY_CHOOSE_US_RESPONSE":
            newState.responseWhyChooseUs = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadImage = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;